import { OrderedMap } from 'immutable';
import indexBy from 'transmute/indexBy';
import { getViewMemberId } from '../../../view-members-schema/public';
export function indexThreadListMembers(members) {
  return OrderedMap(indexBy(getViewMemberId, members));
}